module.exports = __webpack_public_path__ + "static/media/false.af05a8a8.svg";